import moment from 'moment';
import { connect } from 'react-redux';
import React, { Fragment, useState, useEffect, useRef } from 'react';

import { config } from '../../constant';
import cloneDeep from 'lodash.clonedeep';
import { Row, Col, Spin, Tag } from 'antd';
import ReactEcharts from '../../Echarts/Echarts';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import StyledTable from '../../../../../commons/styles/table';
import { ArrayOfObjectsWithAction } from '../../../Mock/MockJson';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';
import { trendLabelTranslation } from '../../../Utils/Adapter/translationAdapter';

const LineTable = (props) => {
  const [option, setOption] = useState(getOption(props));
  const [data, setData] = useState([]);
  const [loading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  // const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [columns, setColumns] = useState([]);
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData();
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData();
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear,
    props.translationCache
  ]);

  const getData = async () => {
    const newOption = cloneDeep(option);
    requestCheck.current = false;
    let json = [];
    let { graphprops } = props;
    let newErrorInAPI = false;
    let newNoDataInDB = false;
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = ArrayOfObjectsWithAction;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }

    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        newErrorInAPI = true;
      } else if (json.length === 0) {
        newNoDataInDB = true;
      }
    } else {
      let newColumns =
        graphprops && graphprops[graphprops.graph] && graphprops[graphprops.graph].columns
          ? JSON.parse(graphprops[graphprops.graph].columns)
          : [];

      let tagnames = [];
      let series = [];
      let legends = [];

      let xaxisLabels = [];
      var label = {
        show: true,
        formatter: '{c}',
        fontSize: 13
      };
      if (json && Array.isArray(json)) {
        json.map((val) => {
          if (tagnames.indexOf(val.Name) === -1) {
            tagnames.push(val.Name);
            legends.push({
              name: val.Description,
              icon: 'roundRect',
              textStyle: {
                fontSize: 18,
                fontWeight: 'bold'
              }
            });
          }
          return {};
        });
      }
      let yAxisData = [];

      if (Array.isArray(props.graphprops.YAxis)) {
        yAxisData = [...props.graphprops.YAxis];
      }

      let yaxis = yAxisData.map((value, index) => {
        let axis = {};
        axis.triggerEvent = true;
        axis.axisLine = {
          lineStyle: {
            color:
              props.graphprops.colors[index] !== undefined
                ? value && value.tags && value.tags.length > 1
                  ? 'white'
                  : props.graphprops.colors[index]
                : 'white'
          }
        };
        axis.axisLabel = { fontSize: 15 };
        axis.max = value.max;
        axis.min = value.min;
        axis.offset = value.offset;
        axis.interval = value.interval;
        axis.position = value.position;
        axis.DateTime = value.DateTime;
        axis.tags = value.tags;
        return axis;
      });

      yaxis.unshift({
        splitLine: {
          show: true,
          lineStyle: {
            color: '#504c4c'
          }
        },
        triggerEvent: true,
        axisLine: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },
        axisLabel: { fontSize: 15 },
        tags: []
      });
      let color = [
        // '#d87c7c',
        // '#919e8b',
        // '#d7ab82',
        // '#6e7074',
        // '#61a0a8',
        // '#efa18d',
        // '#787464',
        // '#cc7e63',
        // '#724e58',
        // '#4b565b',
        // 'steelblue',
        // 'green'
      ];
      tagnames.map((tagval, tagindex) => {
        let data = [];

        json.map((jsonval, jsonindex) => {
          if (tagval === jsonval.Name) {
            if (jsonval.Value < 0) {
              data.push({
                value: jsonval.Value,
                itemStyle: {
                  color: color[jsonindex]
                }
              });
            } else {
              data.push({
                value: jsonval.Value,
                itemStyle: {
                  color: color[jsonindex]
                }
              });
            }
          }
          let valueDate = moment(jsonval.DateTime).utc().format('DD/MM/YYYY HH:mm:ss');
          if (xaxisLabels.indexOf(valueDate) === -1 && tagval === jsonval.Name) {
            if (
              moment(jsonval.DateTime).utc()._isUTC === true &&
              typeof jsonval.DateTime !== 'string'
            ) {
              xaxisLabels.push(moment(jsonval.DateTime).utc().format('DD/MM/YYYY HH:mm:ss'));
            } else if (xaxisLabels.indexOf(jsonval.DateTime) === -1 && tagval === jsonval.Name) {
              xaxisLabels.push(jsonval.DateTime);
            }
          }
          return {};
        });
        if (yaxis.length > 1) {
          yaxis.map((axis, axisindex) => {
            if (axis && axis.tags && axis.tags.indexOf(tagval) !== -1) {
              let linetags = props.graphprops ? props.graphprops.tags : [];
              if (linetags && linetags.length > 0) {
                linetags &&
                  linetags.map(() => {
                    series.push({
                      name: legends[tagindex]['name'],
                      data: data,
                      yAxisIndex: axisindex,
                      label,
                      type: linetags,
                      axisLabel: { fontSize: 15 }
                    });
                    return {};
                  });
              } else {
                series.push({
                  name: legends[tagindex]['name'],
                  data: data,
                  yAxisIndex: axisindex,
                  type: 'bar',
                  label,
                  axisLabel: { fontSize: 15 }
                });
              }
            }
            return {};
          });
        } else {
          let linetags = props.graphprops ? props.graphprops.tags : [];
          if (linetags && linetags.length > 0) {
            linetags &&
              linetags.map(() => {
                series.push({
                  name: legends[tagindex]['name'],
                  data: data,
                  label,
                  type: 'line',
                  axisLabel: { fontSize: 15 }
                });
                return {};
              });
          } else {
            series.push({
              name: legends[tagindex]['name'],
              data: data,
              type: 'line',
              label,
              axisLabel: { fontSize: 15 }
            });
          }
        }
        return {};
      });

      let seriesData = await trendLabelTranslation(series, props.translationCache);
      legends = await trendLabelTranslation(legends, props.translationCache);

      newOption.series = seriesData;
      newOption.legend = {
        textStyle: { color: props.theme.algorithm === "dark" ? 'white' : 'black' },
        data: legends
      };
      newOption.xAxis[0].data = [...xaxisLabels];
      if (
        props.graphprops.colors !== null &&
        props.graphprops.colors !== undefined &&
        props.graphprops.colors.length !== 0
      ) {
        newOption.color = [...props.graphprops.colors];
      } else {
        newOption.color = ['steelblue', 'green', 'rgb(172, 172, 9)', 'red'];
      }
      setOption(newOption);
      setData(json);
      setColumns(newColumns);
      setRefreshDateTime(moment());
    }
    setErrorInAPI(newErrorInAPI);
    setNoDataInDB(newNoDataInDB);
  };

  const onChartClick = (cellData) => {
    if (cellData.seriesType === 'line') {
      let newObject = data.filter((predict) => {
        return predict.DateTime && cellData.name && cellData.seriesName === predict.Description;
      });
      if (newObject && Array.isArray(newObject)) {
        setDataSource(newObject && newObject[0] ? newObject[0].Action : []);
      }
    }
  };

  const onEvents = {
    click: (cellData) => onChartClick(cellData)
  };

  return (
    <Fragment>
      {graphprops && graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      <span>
        {loading === false ? (
          <div style={{ padding: '10px' }}>
            <Row>
              <Col span={24}>
                {noDataInDB === true || errorInAPI === true ? (
                  noDataInDB === true ? (
                    <NoRecordComponent />
                  ) : (
                    <ErrorComponent />
                  )
                ) : (
                  <ReactEcharts
                    option={option}
                    notMerge={true}
                    onEvents={onEvents}
                    lazyUpdate={true}
                    className="react_for_echarts"
                  />
                )}
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <div style={{ padding: '20px' }}>
                  <StyledTable size="small"
                    className="barTable"
                    // rowKey={(record) => record.id}
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}

                    style={{ padding: '0px 10px', marginTop: '12px' }}
                    scroll={{ y: 240 }}
                    bordered
                  />
                </div>
              </Col>
            </Row>
          </div>
        ) : (
         <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%'
              }}
            >
              <Spin spinning={loading} tip="Loading..." />
            </div>
        )}
      </span>
    </Fragment>
  );
};

const getOption = (props) => {
  let option = {
    color: ['tomato', 'steelblue', 'orange', 'yellow', 'green'],
    legend: {
      textStyle: { color: props.theme.algorithm === "dark" ? 'white' : 'black' },
      data: [
        {
          name: 'test1',
          icon: 'roundRect',
          textStyle: {
            fontSize: 15
          }
        }
      ]
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    toolbox: {
      showTitle: false,
      itemSize: 25,
      feature: {
        saveAsImage: {
          backgroundColor: 'black',
          title: 'download',
          name: 'Chart',
          iconStyle: {
            borderColor: '#8c8c8c',
            borderWidth: 2
          }
        }
      }
    },
    xAxis: [
      {
        type: 'category',
        data: [],
        axisLine: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },
        axisTick: {
          show: false,
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },
        axisLabel: {
          color: props.theme.algorithm === "dark" ? 'white' : 'black'
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLine: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },
        axisTick: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },
        axisLabel: {
          color: props.theme.algorithm === "dark" ? 'white' : 'black'
        }
      }
    ],
    series: []
  };
  return option;
};

const mapStateToProps = (state) => {
  return {
    theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};

export default connect(mapStateToProps)(LineTable);
